module.exports = __webpack_public_path__ + "static/media/47.1f8b2fbd.jpg";